import { render, staticRenderFns } from "./FuncionarioDetalleEventos.vue?vue&type=template&id=30e9192a&"
import script from "./FuncionarioDetalleEventos.vue?vue&type=script&lang=js&"
export * from "./FuncionarioDetalleEventos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports